module.exports = __webpack_public_path__ + "static/img/tagprint.3d7aa2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/tagprint.png
// module id = 1Kv4
// module chunks = 92